import { render, staticRenderFns } from "./TwigCodeHelper.vue?vue&type=template&id=de00b8b4&"
import script from "./TwigCodeHelper.vue?vue&type=script&lang=ts&"
export * from "./TwigCodeHelper.vue?vue&type=script&lang=ts&"
import style0 from "./TwigCodeHelper.vue?vue&type=style&index=0&id=de00b8b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports